import { Text } from "@chakra-ui/react";
import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { ColumnId } from "./constants";

type Row = {
  form: {
    errorCount: number;
  };
};

export function buildErrorsColumnDef<T extends Row>(): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.form.errorCount,
    id: ColumnId.Errors,
    header: "Errors",
    headerText: "Errors",
    cell: (props) => {
      const errorCount = props.row.original.form.errorCount;

      return (
        <Text
          color={errorCount ? "black" : "gray.500"}
          fontStyle={errorCount ? "normal" : "italic"}
        >
          {errorCount
            ? `${errorCount} ${errorCount === 1 ? "error" : "errors"}`
            : "No errors"}
        </Text>
      );
    },
  };
}
